module.exports = __webpack_public_path__ + "static/img/3.05b76051.png";